import { useQuery } from '@tanstack/react-query';

import { searchProjectMemberManagement } from '@/features/projects/shared/api/search-project-member-management';
import { ProjectMemberManagementData } from '@/features/projects/shared/types/project-member-management-types';
import { useProjectHubFilterStore } from '@/shared/hooks/use-hub-filter-store';

export const getProjectMemberManagementSearchKey = (args: {
  projectId?: string;
  query?: string;
}) => [
  'projectMemberManagementSearch',
  {
    projectId: args.projectId,
    query: args.query,
  },
];

export function useSearchProjectMemberManagement(projectId?: string) {
  const { searchQuery } = useProjectHubFilterStore();

  return useQuery<ProjectMemberManagementData[]>({
    queryKey: getProjectMemberManagementSearchKey({
      projectId,
      query: searchQuery || undefined,
    }),
    enabled: Boolean(projectId),
    queryFn: async () => {
      if (!projectId) return [];

      const rows = await searchProjectMemberManagement({
        projectId,
        query: searchQuery || undefined,
      });

      const mapped: ProjectMemberManagementData[] = rows.map((row) =>
        row.entity_type === 'invite'
          ? {
              id: row.id,
              memberId: (row.invitation as any)?.org_member_id,
              name: row.name,
              email: row.email,
              role: row.role,
              memberSince: '',
              type: 'invite' as const,
              invitation: row.invitation as any,
              orgMember: row.org_member as any,
            }
          : row.entity_type === 'org_member'
            ? {
                id: row.id,
                name: row.name,
                email: row.email,
                role: row.role,
                memberSince: row.member_since || '',
                type: 'org_member' as const,
                orgMember: row.org_member as any,
              }
            : {
                id: row.id,
                name: row.name,
                email: row.email,
                role: row.role,
                memberSince: row.member_since || '',
                type: 'member' as const,
                projectMember: row.project_member as any,
                orgMember: row.org_member as any,
              },
      );

      return mapped;
    },
  });
}
